import React from 'react'
import Navbar from '../../Components/Navbar/Navbar'
import AboutSection from '../../Components/AboutSection/AboutSection'
import Footer from '../../Components/Footer/Footer'

function About() {
  return (
    <div>
      <Navbar></Navbar>
      <AboutSection></AboutSection>
      <Footer></Footer>
    </div>
  )
}

export default About
